<template>
<div class="chapter">
<div class="inner_page">
<p class="C128"><em><a id="page_vii">Contents</a></em></p><a id="page_vii">
</a><p class="C144"><a id="page_vii"></a><a href="#/html/05_INTRODUCTION__Who_Is_Robert_E__H#page_1">INTRODUCTION. Who Is Robert E. Howard?</a></p>
<p class="C144"><a href="#/html/06_CHAPTER_ONE__Pioneering_Stories#page_5">CHAPTER ONE. Pioneering Stories: The Family of Robert E. Howard</a></p>
<p class="C144"><a href="#/html/07_CHAPTER_TWO__From_Birth_to_Bagwe#page_16">CHAPTER TWO. From Birth to Bagwell</a></p>
<p class="C144"><span href="#/html/08_CHAPTER_THREE__Cross_Cut_and_Bur#page_33" title="Link target outside of Sample">CHAPTER THREE. Cross Cut and Burkett</span></p>
<p class="C144"><span href="#/html/09_CHAPTER_FOUR__The_Birth_of_a_Wri#page_43" title="Link target outside of Sample">CHAPTER FOUR. The Birth of a Writer</span></p>
<p class="C144"><span href="#/html/10_CHAPTER_FIVE__Tattlers_and_Yello#page_51" title="Link target outside of Sample">CHAPTER FIVE. <em>Tattlers</em> and <em>Yellow Jackets</em></span></p>
<p class="C144"><span href="#/html/11_CHAPTER_SIX__Pulp_Fictioneer#page_64" title="Link target outside of Sample">CHAPTER SIX. Pulp Fictioneer</span></p>
<p class="C144"><span href="#/html/12_CHAPTER_SEVEN__The_Other_Side_of#page_77" title="Link target outside of Sample">CHAPTER SEVEN. The Other Side of the Counter</span></p>
<p class="C144"><span href="#/html/13_CHAPTER_EIGHT__A_New_Species_of#page_88" title="Link target outside of Sample">CHAPTER EIGHT. A New Species of Fantasy Fiction</span></p>
<p class="C144"><span href="#/html/14_CHAPTER_NINE__Friends_and_Letter#page_96" title="Link target outside of Sample">CHAPTER NINE. Friends and Letters</span></p>
<p class="C144"><span href="#/html/15_CHAPTER_TEN__Novalyne_Price#page_116" title="Link target outside of Sample">CHAPTER TEN. Novalyne Price</span></p>
<p class="C144"><span href="#/html/16_CHAPTER_ELEVEN__Broken_on_the_Pl#page_130" title="Link target outside of Sample">CHAPTER ELEVEN. Broken on the Plowshare of Fate</span></p>
<p class="C144"><span href="#/html/17_CHAPTER_TWELVE__The_Aftermath#page_138" title="Link target outside of Sample">CHAPTER TWELVE. The Aftermath</span></p>
<p class="C144"><span href="#/html/18_CHAPTER_THIRTEEN__Writing_a_Lega#page_146" title="Link target outside of Sample">CHAPTER THIRTEEN. Writing a Legacy: Selected Stories</span></p>
<p class="C145"><span href="#/html/19_CHAPTER_FOURTEEN__Full_Circle__T#page_171" title="Link target outside of Sample">CHAPTER FOURTEEN. Full Circle: The Publishing Journey of a Barbarian</span></p>
<p class="C144"><span href="#/html/20_Afterword#page_192" title="Link target outside of Sample">Afterword</span></p>
<p class="C144"><span href="#/html/21_Acknowledgments#page_195" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="C144"><span href="#/html/22_Notes#page_197" title="Link target outside of Sample">Notes</span></p>
<p class="C144"><span href="#/html/23_Index#page_229" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?6fe908e0